import React from 'react';
import { IconProps } from '.';

const SvgColoredGift = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FFC2E1'
        d='M3 7a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8h1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H3Z'
      />
      <path
        fill='#FF71BA'
        d='M7.684 7.043h3.03V22h2.572V7.043h3.03c.731 0 1.432-.271 1.949-.753a2.488 2.488 0 0 0 .807-1.819c0-.682-.29-1.336-.807-1.818a2.858 2.858 0 0 0-1.948-.753C14.01 1.9 12.69 3.737 12 5.215 11.31 3.737 9.99 1.9 7.684 1.9c-.73 0-1.432.27-1.948.753a2.488 2.488 0 0 0-.807 1.818c0 .682.29 1.336.807 1.819a2.858 2.858 0 0 0 1.948.753Z'
      />
    </svg>
  );
};

export default SvgColoredGift;
